<template>
  <v-app>
    <side-bar-layout></side-bar-layout>

    <v-main>
      <div v-if="$vuetify.theme.dark && $vuetify.breakpoint.smAndUp">
        <div class="circle-container" v-for="i in 300" :key="i">
          <div class="circle"></div>
        </div>
      </div>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { useUXState } from "@/composables/ux.js";
import SideBarLayout from "@/components/SideBar/SideBarLayout.vue";
export default {
  components: { SideBarLayout },
  name: "App",
  setup() {
    const { locale, darkMode } = useUXState();
    return { locale, darkMode };
  },
  created() {
    this.$i18n.locale = this.locale;
    this.$vuetify.theme.dark = this.darkMode;
  },
  data: () => ({
    //
  })
};
</script>
<style lang="scss" src="@/scss/app.scss"></style>
